import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { lastValueFrom } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { StandardAuthService } from '../../services/auth/standard-auth.service';
import { EnvironmentService } from '../../services/environment.service';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  currentUrl = '';
  hasCode = false;

  get redirectUrl(): string {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = window.location.port;
    const portSection = port ? `:${port}` : '';
    return `${protocol}//${hostname}${portSection}/login`;
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: StandardAuthService,
    private environmentService: EnvironmentService
  ) {

    this.activatedRoute.queryParams.subscribe(async params => {
      if (params['code']) {
        this.hasCode = true;
        await lastValueFrom(this.authService.loginWithAuthorizationCode(params['code'], this.redirectUrl));
        await lastValueFrom(this.authService.fetchUserToken())
        this.router.navigate(['/home']);
      }
    });
  }

  async redirectToLogin() {
    let loginUrl = await lastValueFrom(this.authService.getLoginUrl(this.redirectUrl));
    window.location.href = loginUrl;
  }

  public get isEmbedded(): boolean {
    return this.environmentService.isEmbedded;
  }

}
